

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceFactory', function () {
    // initial choiceBalanceState checkbox is unselected
    var state = {
        checkbox: undefined
    };

    var get = function get() {
        return state;
    };

    var set = function set(data) {
        return _squid.$util.extend(state, data);
    };

    var getPadAndCheckboxStatus = function getPadAndCheckboxStatus() {
        var balanceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var planList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var isChecked = balanceList.some(function (balance) {
            return balance.checked;
        });
        var hasPad = planList.some(function (plan) {
            return plan.primaryFs.subtype === 'PAD';
        });

        return {
            isChecked: isChecked,
            hasPad: hasPad
        };
    };

    return {
        get: get,
        set: set,
        getPadAndCheckboxStatus: getPadAndCheckboxStatus
    };
});

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-select-fi/factory.js
// module id = ./pages/xo-select-fi/factory.js
// module chunks = main-code-split